import { mergeTasks } from "@/utils/UTasks";

import {
	VIEW_SEARCH_GROUP,
	PROJECT_SEARCH_GROUP,
	TASK_SEARCH_GROUP,
} from "@/constants/CSearch";

import { TFormatedSearchGroups, TSearchResults } from "@/types";

export const computeSearchResults = (
	resp: TSearchResults,
	_mergeTasks = false
) => {
	const ret: TFormatedSearchGroups[] = [];

	if (resp.tasks) {
		const hits = resp.tasks.hits.map((t) => ({
			value: t.id,
			label: t.name,
			group: TASK_SEARCH_GROUP,
			...t,
			TaskId: t.id,
		}));
		ret.push({
			label: "Tasks",
			options: _mergeTasks ? mergeTasks(hits) : hits,
			total: resp.tasks.nbHits,
		});
	}

	if (resp.projects)
		ret.push({
			label: "Projects",
			options: resp.projects.hits.map((p) => ({
				value: p.id,
				label: p.name,
				group: PROJECT_SEARCH_GROUP,
				...p,
				ProjectId: p.id,
			})),
			total: resp.projects.nbHits,
		});

	if (resp.views)
		ret.push({
			label: "Views",
			options: resp.views.hits.map((c) => ({
				value: c.id,
				label: c.name,
				group: VIEW_SEARCH_GROUP,
				...c,
				ViewId: c.id,
			})),
			total: resp.views.nbHits,
		});

	return ret;
};
